module.exports = __webpack_public_path__ + "img/collectEmpty.2168d3f8.png";